import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { ConfigProvider } from './contexts/ConfigContext';

import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import '../src/utils/helpers';
import ErrorBoundary from './components/ErrorBoundary';
import DisableFeatures from './utils/DisableFeatures';
import ProtectionWrapper from './ProtectionWrapper';

const container = document.getElementById('root');
const root = createRoot(container);

if (module.hot) {
  module.hot.accept();
}

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConfigProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          {/*<DisableFeatures>*/}
          {/* <ProtectionWrapper> */}
            <App />
          {/* </ProtectionWrapper> */}
          {/* </DisableFeatures> */}
        </LocalizationProvider>
      </ConfigProvider>
    </Provider>
  </ErrorBoundary>
);

reportWebVitals();
